// Lowercase letters and digits without 0, 1, i, l, o, so a password read aloud
// or copied by hand cannot be misread. 31 symbols x 16 is about 79 bits. Same
// alphabet and shape as the server's generateSharePassword (botspot_node
// src/Publications/publicationPolicy.ts).
const ALPHABET = 'abcdefghjkmnpqrstuvwxyz23456789';
// Largest multiple of the alphabet size that fits in a byte, for unbiased picks.
const UNBIASED_LIMIT = 256 - (256 % ALPHABET.length);

function randomSymbol() {
  const bytes = new Uint8Array(1);
  for (;;) {
    window.crypto.getRandomValues(bytes);
    if (bytes[0] < UNBIASED_LIMIT) return ALPHABET[bytes[0] % ALPHABET.length];
  }
}

/** A strong, readable private-link password such as `k7mq-x3ta-9pwe-hn4c`. */
export function generateSharePassword() {
  const groups = [];
  for (let group = 0; group < 4; group += 1) {
    let chunk = '';
    for (let index = 0; index < 4; index += 1) chunk += randomSymbol();
    groups.push(chunk);
  }
  return groups.join('-');
}
